import React, { Component } from 'react'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.js'

export class InfoSection extends Component {
  componentDidMount() {
    $('.ui.accordion-1').accordion()
    $('.ui.accordion-2').accordion()
  }

  render() {
    return (
      <div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='chapter-1'>
              <h3>Das System</h3>
              <div className='ui styled accordion accordion-1'>
                <div className='title'>
                  <i className='dropdown icon' />
                  Proporz oder Majorz?
                </div>
                <div className='content'>
                  <p className='transition hidden'>
                    In der Stadt Bern werden der Gemeinderat (5-köpfige
                    Stadtregierung, bzw. Exekutive) UND der Stadtrat
                    (80-köpfiges Parlament, bzw. Legislative) im
                    Proporzverfahren gewählt. Das heisst: Zuerst wird gezählt,
                    wie viele Stimmen die einzelnen Listen bekommen haben, dann
                    werden die Sitze im Verhältnis (Proporz) auf die Listen
                    verteilt.
                  </p>
                  <p>
                    Erst am Schluss wird geschaut, welche Personen auf den
                    einzelnen Listen am meisten Stimmen erhalten haben und die
                    Sitze erhalten, die der entsprechenden Liste zustehen.{' '}
                  </p>
                  <p>
                    Wichtiges Detail: Listenverbindungen sind nur bei den
                    Stadtratswahlen zugelassen.
                  </p>
                  <p>
                    Kontrollfrage: Ist es möglich, dass jemand auf einer Liste
                    Rang 1 einnimmt und doch keinen Sitz gewinnt? – Ja. Dann
                    nämlich, wenn seine Liste insgesamt so wenige Stimmen
                    erhält, dass es nicht für einen Sitz reicht.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Kumulieren und panaschieren?
                </div>
                <div className='content'>
                  <p>
                    Wählen kann ein kreativer Vorgang sein. Grundsätzlich kann
                    man nicht mehr Namen aufschreiben als es Zeilen hat, sonst
                    ist fast alles erlaubt (siehe: Anfängerfehler).
                  </p>
                  <p>
                    Dabei gibt es zwei wichtige Gestaltungsmöglichkeiten: Man
                    kann Namen erstens doppelt aufschreiben, bzw. kumulieren
                    (wenn eine vorgedruckte Liste voll ist, muss man dafür einen
                    anderen Name streichen) und man kann Namen von anderen
                    Listen «importieren», bzw. panaschieren.
                  </p>
                  <p>
                    Selbstverständlich kann man die listenfremden Namen auf der
                    eigenen Liste auch kumulieren.
                  </p>
                  <p>
                    Kontrollfrage: Kann man auf einer vorgedruckten Liste einen
                    Namen streichen und den gleichen Namen an anderer Stelle von
                    Hand wieder einfügen? – Ja. Die Leute im
                    Abstimmungsausschuss werden sich allerdings ihre Sache dabei
                    denken.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Was wollen die Parteien?
                </div>
                <div className='content'>
                  <p>
                    Die Parteien empfehlen den Wählerinnen und Wählern meistens,
                    ihre vorgedruckte Liste unverändert einzuwerfen. Die Absicht
                    dahinter: Auf diese Weise gehen erstens alle Linien an die
                    Partei, was für sie das wichtigste ist (da ja zuerst die
                    Linien als Parteistimmen zählen).
                  </p>
                  <p>
                    Zweitens geraten so keine fremden Kandidaten auf die Liste
                    (jeder parteifremde Name bedeutet eine Stimme weniger für
                    die Partei, noch schlimmer sind kumulierte Namen von Fremden
                    – unbedenklicher sind Namen, die von verbundenen Listen
                    stammen).
                  </p>
                  <p />
                  <p>
                    Und drittens werden Gewichtungen der Partei übernommen – zum
                    Beispiel, wenn Spitzenkandidaten vorkumuliert sind.
                  </p>
                  <p>
                    Kontrollfrage: Muss man eine Parteiliste unverändert
                    einwerfen. – Nein, das ist bloss ein frommer Wunsch der
                    Partei.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Wann gibt es einen Sitz?
                </div>
                <div className='content'>
                  <p>
                    Im Proporzverfahren, wie es in der Stadt Bern gilt, hat eine
                    Liste dann einen Sitz auf sicher, wenn sie eine bestimmte
                    Prozentzahl der abgegebenen Stimmen erreicht. Dabei kommt es
                    auf die Anzahl der zu vergebenden Sitze an.
                  </p>
                  <p>
                    Die entscheidende Prozentzahl wird so errechnet: 100 geteilt
                    durch die um eins vermehrte Zahl der zu vergebenden Sitze.
                  </p>
                  <p>
                    Für den Gemeinderat mit 5 Sitzen sieht die Formel so aus:
                    100 geteilt durch (5+1) = 16,67. Erreicht eine Partei
                    mindestens diesen Wert oder das Zwei-, Drei- oder Vierfache
                    davon, hat sie einen, zwei, drei oder vier Sitze auf sicher.
                    Im 80-köpfigen Stadtrat braucht es 1,235 Prozent der Stimmen
                    für einen Sitz (100 durch 81).
                  </p>
                  <p>
                    Kontrollfrage: Können in einem fünfköpfigen Gremium sechs
                    Sitze vergeben werden? Nein. Auch theoretisch nicht.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Listenverbindungen
                </div>
                <div className='content'>
                  <p>
                    Zwei oder mehr Parteien können ihre Listen verbinden. Bei
                    der Sitzverteilung werden die verbundenen Listen in einer
                    ersten Phase als «ein Organismus» betrachtet. Nachdem klar
                    ist, wie viele Sitze dieser Organismus erhält, werden diese
                    Sitze intern verteilt.
                  </p>
                  <p>
                    Der Vorteil von Listenverbindungen: Es gehen weniger
                    überschüssige Stimmen verloren. Beispiel: Partei A und B
                    haben Stimmen erhalten für je anderthalb Sitze. Ohne
                    Listenverbindung kommen sie auf je einen Sitz. Mit einer
                    Listenverbindung holen sie drei Sitze (auch die beiden
                    halben). Welche Partei den dritten Sitz erhält, wird in
                    einer zweiten Verteilung entschieden.
                  </p>
                  <p>
                    Meistens verbinden Parteien ihre Listen, die sich ohnehin
                    schon nahe stehen – so wie zum Beispiel SVP und JSVP oder SP
                    und Grüne.
                  </p>
                  <p>
                    Kontrollfrage: Dürfen zum Beispiel die FDP und die EDU ihre
                    Listen verbinden? Ja. Allerdings ist nicht alles, was
                    erlaubt ist, auch logisch.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Unterlistenverbindungen
                </div>
                <div className='content'>
                  <p>
                    Diese funktionieren nach dem gleichen Prinzip wie
                    Listenverbindungen. Es geht einfach eine Ebene weiter.
                    Beispiel: SVP und JSVP können eine Unterlistenverbindung
                    (SVP + JSVP) und dann noch eine Listenverbindung eingehen:
                    ((SVP + JSVP) + (FDP) + (CVP)).
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Spezialfall Listenverbindung in Bern
                </div>
                <div className='content'>
                  <p>
                    Wichtiger Punkt: Bei den Berner Stadtratswahlen (80 Sitze)
                    sind Listenverbindungen erlaubt und werden auch häufig
                    gemacht. Bei den Gemeinderatswahlen (5 Sitze) hingegen
                    nicht!
                  </p>
                  <p />
                  Das ist der tiefere Grund dafür, warum sich Kandidierende aus
                  verschiedenen Parteien auf einzelne Listen drängen. Wären
                  Listenverbindungen erlaubt, könnten zum Beispiel die
                  Kandidaten von CVP, BDP, GLP und EVP auf eigenen Listen
                  antreten und bräuchten keine Einheitsliste zu bilden (wobei
                  das bei nur fünf Kandidaten etwas unübersichtlich würde).{' '}
                  <p>
                    Der Zweck der Einheitslisten (Mitte-Liste, Rot-Grün-Mitte,
                    Bürgerliches Bündnis) ist somit der, überschüssigen Stimmen
                    eine Wirkung zu geben, die sonst einfach verpuffen würden.
                  </p>
                  <p>
                    Kontrollfrage: Kann man auf Listen, die nicht verbunden
                    sind, kumulieren? – Ja, sicher.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='chapter-2'>
              <h3>Tipps, Tricks und Trivia</h3>
              <div className='ui styled accordion accordion-1'>
                <div className='title'>
                  <i className='dropdown icon' />
                  Anfängerfehler
                </div>
                <div className='content'>
                  <p className='transition hidden'>
                    <ul>
                      <li>
                        Bei brieflicher Stimmabgabe den Stimmausweis nicht
                        unterschreiben. Der Wahlzettel ist ungültig.
                      </li>
                      <li>
                        Den leeren Wahlzettel verwenden und mit einer
                        Parteibezeichnung versehen, aber keinen Kandidaten
                        aufschreiben. Es zählt keine einzige Linie für die
                        Partei.
                      </li>
                      <li>
                        Den leeren Wahlzettel verwenden, einen oder zwei Namen
                        darauf schreiben, aber keine Parteibezeichnung
                        hinzufügen. Die leeren Linien zählen für niemanden.
                      </li>
                      <li>
                        Nur die Kandidatennummern aufschreiben ohne die Namen.
                        Keine Stimme ist gültig. Das Umgekehrte funktioniert
                        aber, also Namen ohne Nummern.
                      </li>
                      <li>
                        Personen aufschreiben, für die kein Wahlvorschlag
                        vorliegt (zum Beispiel: Müslüm). Der Name wird vom
                        Wahlausschuss gestrichen. Die frei werdende Linie ist
                        aber gültig.
                      </li>
                      <li>
                        Den Wahlzettel mit Schreibmaschine ausfüllen. Der
                        Wahlzettel wird sogar dann als ganzer ungültig, wenn nur
                        ein einziger Name mit Schreibmaschine geschrieben wird –
                        oder wenn bei vorgedruckten Zetteln ein Name mit Tipp-Ex
                        gestrichen wird. Das heisst: Jede Änderung, sogar das
                        Durchstreichen muss von Hand erfolgen.
                      </li>
                      <li>
                        Den Wahlzettel mit der eigenen Unterschrift, mit
                        Kennzeichnungen, Parolen oder Schimpfwörtern versehen
                        oder Affen darauf zeichnen. Er wird ungültig.
                      </li>
                    </ul>
                  </p>
                  <p>
                    Kontrollfrage: Muss man seinen Namen auf den Wahlzettel
                    schreiben? – Nein, keinesfalls. Es ist nur dann
                    empfehlenswert, wenn man selber kandidiert.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Parteien stärken und schwächen
                </div>
                <div className='content'>
                  <p>
                    Eine Partei maximal unterstützen: Die Liste mit
                    Parteibezeichnung versehen und mindestens einen Kandidaten
                    dieser Partei aufschreiben. Ob die übrigen Linien ausgefüllt
                    sind, ist egal. Sie zählen alle für die Partei.
                  </p>
                  <p>
                    Wer auf die Liste «seiner» Partei Kandidaten anderer
                    Parteien aufschreibt, schwächt «seine» Liste. Sie erhält
                    entsprechend weniger Parteistimmen. Die Partei der
                    panaschierten Kandidaten erhält dafür zusätzliche
                    Listenstimmen.
                  </p>
                  <p>
                    Kontrollfrage: Kann man auf eine SP-Liste nur FDP-Kandidaten
                    aufschreiben? – Ja, es ist dann am Schluss aber eine
                    FDP-Liste.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Kandidaten stärken und schwächen
                </div>
                <div className='content'>
                  <p>
                    Einen einzelnen Kandidaten stärken: Die Maximalmethode
                    besteht darin, «seinen» Kandidaten zweimal auf die Liste zu
                    schreiben und alle anderen zu streichen.
                  </p>
                  <p>
                    Wer gerne Namen durchstreicht, kann auch die vorgedruckte
                    Liste nehmen, seinen Kandidaten ein zweites Mal aufschreiben
                    und alle anderen durchstreichen. Die dritte Variante: Eine
                    leere Liste nehmen, seinen Kandidaten zweimal
                    draufschreiben. Nicht vergessen: Den Parteinamen auf die
                    Liste schreiben. Die leeren Linien zählen alle für die
                    Partei.
                  </p>
                  <p>
                    Einen Kandidaten schwächen: Der erste Schritt besteht darin,
                    ihn gar nicht zu wählen. In einem zweiten Schritt kumuliert
                    man die Kandidaten, die ungefähr gleich stark sind wie er
                    oder leicht hinter ihm liegen. So erhöht man die
                    Wahrscheinlichkeit, dass er von hinten überholt, selber aber
                    nicht nach vorne kommt.
                  </p>
                  <p>
                    Kontrollfrage: Ist es legal, wenn man als Mann eine
                    Kandidatin streicht, ohne es in irgendeiner Form
                    gendermässig zu kompensieren? – Ja, es ist legal, aber es
                    ist nicht gerade die Art des feinen Mannes...
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Die Illegalität
                </div>
                <div className='content'>
                  <p>
                    Die Grenze zur Illegalität ist rasch überschritten. Verboten
                    ist das planmässige Einsammeln, Ausfüllen oder Abändern von
                    Wahl- oder Stimmzetteln. Verboten ist, einen
                    Stimmberechtigten an der Ausübung seines Wahlrechts zu
                    hindern oder ihn zu nötigen, sein Wahlrecht in einem
                    bestimmten Sinn auszuüben.
                  </p>
                  <p>
                    Verboten ist weiter, jemandem ein Geschenk oder andere
                    Vorteile anzubieten, damit er in einem bestimmten Sinn
                    abstimmt oder, umgekehrt, an einer Abstimmung nicht
                    teilnimmt.
                  </p>
                  <p>
                    Kontrollfrage: Darf man sich selber dazu überreden, an einer
                    bestimmten Wahl nicht teilzunehmen? – Ja, wenn man
                    einverstanden ist, gibt es kein Problem.
                  </p>
                </div>
                <div className='title'>
                  <i className='dropdown icon' />
                  Da ärgert sich der Wahlausschuss
                </div>
                <div className='content'>
                  <p>
                    Wenn Sie ihren Stimmzettel sieben Mal falten, werden die
                    Leute im Wahlausschuss keine Freude haben. Aber es ist
                    erlaubt. Im Gesetz über die politischen Rechte steht
                    lediglich, der Zettel sei ins dafür vorgesehene Kuvert zu
                    legen.
                  </p>
                  <p>
                    Allerdings gibt es so etwas wie eine natürliche Limite: Es
                    ist unmöglich, einen Stimmzettel – oder irgend einen Zettel
                    – mehr als sieben Mal zu falten. Sie können es ausprobieren.
                  </p>
                  <p>
                    Wenn Sie, aus purer Freude am Wählen, einen vorgedruckten
                    Wahlzettel nehmen, alle Namen streichen und von Hand neue
                    Namen hinschreiben, werden die Leute im Wahlausschuss
                    einander anschauen.
                  </p>
                  <p>
                    Kontrollfrage: Dürfen die Leute vom Wahlausschuss während
                    des Auszählens über bestimmte Wahlzettel Witze reissen? –
                    Ja.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
